import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Divider } from 'braid-design-system';

import useWindow from '../../../../../../hooks/useWindow';
import useACL from '../../../../../../hooks/useACL';

import DocumentClickHandler from '../../../../../Handlers/DocumentClickHandler';
import DocumentKeyEventHandler from '../../../../../Handlers/DocumentKeyEventHandler';

import { selectors as userSelectors } from '../../../../../../store/user';

import ActiveAccount from '../ActiveAccount/ActiveAccount';
import User from '../User/User';
import PageLinks from './PageLinks/PageLinks';
import SavedSearchList from '../SavedSearchList/SavedSearchList';
import AccountsList from '../AccountsList/AccountsList';
import SignOut from '../SignOut/SignOut';
import TrialWarning from '../TrialWarning/TrialWarning';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';

import { ACL, KeyMap } from '../../../../../../types';

import * as styles from './Menu.css';
import MenuLanguageSwitcher from '../MenuDrawer/MenuLanguageSwitcher/MenuLanguageSwitcher';

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { scrollToTop } = useWindow();
  const { hasAccess } = useACL();

  const userFirstName = useSelector(userSelectors.getUserFirstNameSelector);
  const advertiserName = useSelector(userSelectors.getAdvertiserNameSelector);
  const accountNumber = useSelector(
    userSelectors.getAdvertiserAccountNumberSelector,
  );
  const isConnectedTalentSearchUser = useSelector(
    userSelectors.isConnectedTalentSearchUserSelector,
  );
  const premiumContract = useSelector(userSelectors.getPremiumContract);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = () => {
    setIsOpen(false);
    scrollToTop();
  };

  const isOnTrial = premiumContract && premiumContract.type === 'trial';

  return (
    <Box className={styles.container} display="flex" alignItems="center">
      <PageLinks onSelect={handleSelect} />

      <Box display="flex">
        <LanguageSwitcher />

        <User
          userFirstName={userFirstName}
          advertiserName={advertiserName}
          isConnectedTalentSearchUser={isConnectedTalentSearchUser}
          isOnTrial={isOnTrial}
          isToggled={isOpen}
          onClick={toggleMenu}
        />
      </Box>

      {isOpen && (
        <DocumentClickHandler onOutsideElementClick={toggleMenu}>
          <DocumentKeyEventHandler
            keyMap={{
              [KeyMap.Escape]: toggleMenu,
            }}
          >
            <Box background="surface" className={styles.menu}>
              <Box background={'body'} padding={'medium'}>
                <ActiveAccount
                  advertiserName={advertiserName}
                  userFirstName={userFirstName}
                  accountNumber={accountNumber}
                />
              </Box>
              <Divider />
              {isOnTrial && premiumContract && (
                <TrialWarning premiumContract={premiumContract} />
              )}
              {hasAccess(ACL.SEARCH_FEATURE.SAVED_SEARCHES) && (
                <SavedSearchList onSelect={handleSelect} hasScroll={true} />
              )}
              <AccountsList
                activeAccountNumber={accountNumber}
                onSelect={handleSelect}
                hasScroll={true}
              />
              <MenuLanguageSwitcher />
              <SignOut />
            </Box>
          </DocumentKeyEventHandler>
        </DocumentClickHandler>
      )}
    </Box>
  );
};

export default Menu;
